import { reducerWithInitialState } from "typescript-fsa-reducers";
import {
  getSupportedLanguages,
  getUserPreferences,
  saveUserPreferences
} from "./actions";

export interface UserPreferences {
  supportedLanguages: string[];
  language: string | null;
}

const initialState = { supportedLanguages: [], language: null };

export default reducerWithInitialState<Readonly<UserPreferences>>(initialState)
  .case(getSupportedLanguages.async.done, (state, { result }) => {
    return { ...state, supportedLanguages: result };
  })
  .case(getUserPreferences.async.done, (state, { result }) => {
    const language = result.language;

    return { ...state, language };
  })
  .case(saveUserPreferences.async.done, (state, { result }) => {
    return {
      ...state,
      language: result.language
    };
  });



// WEBPACK FOOTER //
// ./src/preferences/reducer.ts